import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "./DiffusionOptionsDesc.css";

import IpaInputImage2 from '../../../image/for-iopaint/image-prompt/boy-man-h200.png';
import IpaMaskImage2 from '../../../image/for-iopaint/image-prompt/boy-man-ipa-mask-h200.png';
import IpaImage2 from "../../../image/for-iopaint/image-prompt/statue-h200.png";

import StepImage1 from "../../../image/for-iopaint/option-description/step/convert-s4-h100.jpeg";
import StepImage2 from "../../../image/for-iopaint/option-description/step/convert-s8-h100.jpeg";

function DiffusionOptionsDescStep() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">       
          {t('diffusionOptions22', 'When lower values are used, generated image does not incorporate other inputs so much, and image is similar to input image.')}
          {' '}
          {t('diffusionOptions23', 'When higher value is used, generated image incorporate other input values more, and usually higher quality images are generated.')}
          <br/>

        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaInputImage2}
              />
              Input
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaImage2}
              />
              Image prompt
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={IpaMaskImage2}
              />
              Selected
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={StepImage1}
              />
              4 step
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StepImage2}
              />
              8 step
            </div>
          </div>
        </div>
      </div>
    )
  }


export default DiffusionOptionsDescStep